import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

import { FaPhoneAlt } from "react-icons/fa";
import { useContext } from "react";
import { SearchContext } from "./Contexts/Context";
import { getFraqciaBySlug, getKomisiaBySlug } from "../service/service";

function SakrebuloFraqciebi1() {
  const { id } = useParams();
  const { language } = useContext(SearchContext);
  const [menu, setMenu] = useState({});
  const [komisia, setKomisia] = useState([]);
  const [loading, setLoading] = useState(false);
  const [komisiaChairman, setKomisiaChairman] = useState(null);
  const [loadingChairman, setLoadingChairman] = useState(false);
  const [komisiaNotChairman, setKomisiaNotChairman] = useState([]);
  const [fraqcia, setFraqcia] = useState([]);

  useEffect(() => {
    const link = "https://khulo.gov.ge/api/site_menu1.php";
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        // console.log('data.menu',data.menu)
        setMenu(data.menu);

        //  console.log('menu', menu)

        //  console.log('object entries', Object.entries(menu))

        Object.entries(menu).map((item) => {
          if (item[1].level == 1) {
            //console.log('entries item', item[1].name_eng , item[1].level)
          }
        });
      });
  }, []);
  const presscenterList = Object.entries(menu).length
    ? Object.entries(menu).map((item, index) => {
        if (item[1].level == 1 && item[1].name_geo == "საკრებულო") {
          return Object.entries(menu).map((qveItem, index) => {
            if (qveItem[1].parent_id == item[1].cat_id) {
              return (
                <span
                  key={index}
                  className={
                    window.location.href.includes(qveItem[1].slug)
                      ? "active"
                      : ""
                  }
                >
                  <Link to={`/${qveItem[1].slug}`}>{qveItem[1].name_geo}</Link>
                </span>
              );
            }
          });
        }
      })
    : "LOADING";

  const [komisiaMembers, setKomisiaMembers] = useState([]);
  const [members, setMembers] = useState([]);
  const [tavmjdomare, setTAvmjdomare] = useState({});
  useEffect(() => {
    const link = `https://khulo.gov.ge/api/members.php?`;
    fetch(link)
      .then((response) => response.json())
      .then((data) => {
        data.map((item) => {
          item.geo.comision.map((com) => {
            if (com == id) {
              komisiaMembers.push(item);
            }
          });
        });

        data.map((item) => {
          if (item.geo.chairman == id) {
            setTAvmjdomare(item);
          }
        });

        setMembers(data);
      });
  }, []);

  //   const tavmjdomareUI = Object.entries(tavmjdomare).length ? (
  //     <>
  //       <span>
  //         {language == 1 ? tavmjdomare.geo.title : tavmjdomare.eng.title}
  //       </span>
  //       <span>
  //         {language == 1 ? tavmjdomare.geo.chairman : tavmjdomare.eng.chairman}
  //       </span>
  //       <Helmet>
  //         <title>
  //           {language == 1 ? tavmjdomare.geo.chairman : tavmjdomare.eng.chairman}
  //         </title>
  //       </Helmet>
  //       <div className="half">
  //         <span>{tavmjdomare.geo.email}</span>
  //         <span>
  //           <FaPhoneAlt /> {tavmjdomare.geo.mobile}
  //         </span>
  //       </div>
  //     </>
  //   ) : (
  //     ""
  //   );
  const ref = useRef(null);
  const [width, setWidth] = useState(10);
  useLayoutEffect(() => {
    setWidth(ref.current.offsetWidth);
  });

  const komisiaFC = async (slug) => {
    try {
      const { fraqcia, members } = await getFraqciaBySlug(slug);

      if (!fraqcia && !members) {
        console.log("No data returned from getFraqciaBySlug");
        setLoading(true);
        setLoadingChairman(true);
        return;
      }
      setFraqcia(fraqcia);

      if (members && Array.isArray(members)) {
        setKomisia(members);

        // Find chairman
        const chairman = members.find((item) => item?.is_chairman === true);
        if (chairman) {
          setKomisiaChairman(chairman);
        }

        // Find non-chairman members
        const notChairmanMembers = members.filter(
          (item) => item?.is_chairman === false
        );
        setKomisiaNotChairman(notChairmanMembers);

        setLoadingChairman(true);
      }
      setLoading(true);
    } catch (error) {
      console.error("Error fetching fraqcia:", error);
      setLoading(true);
      setLoadingChairman(true);
    }
  };

  console.log("komisiaChairman", komisiaChairman);

  useEffect(() => {
    komisiaFC(id);
  }, [id]);

  const KomisiaView = () => {
    return loadingChairman ? (
      <>
        <span>
          {komisiaChairman?.member?.full_name + " - ფრაქციის თავმჯდომარე"}
        </span>
        <span> {komisiaChairman?.fraqcia?.name}</span>
        <div className="half">
          <span>
            {komisiaChairman?.member.email
              ? komisiaChairman?.member.email
              : "არ არის მითითებული"}
          </span>
          <span>
            <FaPhoneAlt />{" "}
            {komisiaChairman?.member.mobile
              ? komisiaChairman?.member.mobile
              : "არ არის მითითებული"}
          </span>
        </div>
      </>
    ) : (
      <div>Loading...</div>
    );
  };

  return (
    <motion.div
      intial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="news-container margin-280px">
        <header>
          <span className="big" ref={ref} style={{ marginRight: width / 2 }}>
            {" "}
            {language == 1 ? "საკრებულო" : "KHULO CITY ASSEMBLY"}
          </span>
          <span>
            {language == 1 ? "საკრებულოს ფრაქციები" : "ASSEMBLY COMISSIONS"}
          </span>
        </header>
        <div>
          <div className="sakrebulo-landing">
            <div className="landing-container">
              <div className="komisia">
                <div className="">
                  {loadingChairman ? (
                    <>
                      <KomisiaView />
                      <header>
                        {language == 1
                          ? "საკრებულოს ფრაქციები წევრები"
                          : "COMISSION MEMBERS"}
                      </header>
                      {komisiaNotChairman?.map((item, index) => {
                        return (
                          <span key={index}>
                            {item?.member?.full_name}
                            {item?.is_deputy_chairman
                              ? " - ფრაქციის მოადგილე"
                              : ""}
                          </span>
                        );
                      })}
                    </>
                  ) : (
                    "loading"
                  )}

                  {/*  */}
                </div>

                <div className="">
                  <img src={fraqcia.image} alt="komisiaimage" />
                </div>
              </div>
            </div>
          </div>
          <div className="presscenter-info">{presscenterList}</div>
        </div>
      </div>
    </motion.div>
  );
}

export default SakrebuloFraqciebi1;
